module.exports = __webpack_public_path__ + "Roboto-Thin.94998475f6aea65f5584.ttf";


//////////////////
// WEBPACK FOOTER
// /var/www/html/prod/resources/assets/frontend/src/assets/font/roboto/Roboto-Thin.ttf
// module id = ../../../../../src/assets/font/roboto/Roboto-Thin.ttf
// module chunks = 29